import React, { useLayoutEffect, useRef, useState } from "react";
import gsap from "gsap";
import styles from "./Topbar.module.css";
import Logo from "../../assets/logo1.png";
import { useNavigate } from "react-router-dom";
import useActiveSection from "../../CustomHooks/useActiveSection";
// Only used by the secondary-bar trigger, commented out below.
// import svg from "../../assets/svg";
import AdditionalTopBar from "./AdditionalTopBar";

/* Document order, so the scrollspy can pick the first section in the band. */
const SECTION_IDS = [
  "home",
  "about",
  "impact",
  "why-puducherry",
  "vision-mission",
  "ljk-party",
  // "events" and "news" are parked in App.js; ids absent from the DOM are
  // skipped by the observer, so restoring them here is all that is needed.
  // "events",
  // "news",
  "gallery",
];

/* Nav order as shown in the header. Events and News are parked with their
   landing sections in App.js - restore them here alongside those. */
const NAV_ITEMS = [
  { label: "Home", section: "home" },
  { label: "About", section: "about" },
  { label: "Impact", section: "impact" },
  { label: "Why Puducherry", section: "why-puducherry" },
  { label: "Vision & Mission", section: "vision-mission" },
  // { label: "Events", section: "events" },
  // { label: "News", section: "news" },
  { label: "Gallery", section: "gallery" },
];

/* Standalone routes map onto the nav item they belong to. */
const ROUTE_SECTIONS = {
  "/all-events": "events",
  "/all-news": "news",
  "/all-album": "gallery",
};

export default function Topbar() {
  const [open, setOpen] = useState(false);
  const [openTopBar, setOpenTobBar] = useState(false)
  const navigate = useNavigate();

  // Derived from the route and the scroll position rather than held in state,
  // so it cannot drift out of step with where the visitor actually is.
  const active = useActiveSection(SECTION_IDS, ROUTE_SECTIONS);

  const navRef = useRef(null);
  const indicatorRef = useRef(null);
  const placedRef = useRef(false);

  /**
   * Slide the highlight to whichever item is current, instead of having the
   * background pop off one item and onto another. Measured from the live DOM
   * so it stays correct as the nav reflows.
   */
  useLayoutEffect(() => {
    const nav = navRef.current;
    const indicator = indicatorRef.current;
    if (!nav || !indicator) return undefined;

    const reduced =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const place = () => {
      const target = nav.querySelector(`[data-section="${active}"]`);
      // Below 990px the nav is a stacked dropdown and the plain .activeNav
      // background takes over, so the indicator stays hidden.
      const isRow = window.innerWidth >= 990;

      if (!target || !isRow) {
        gsap.set(indicator, { autoAlpha: 0 });
        placedRef.current = false;
        return;
      }

      const navBox = nav.getBoundingClientRect();
      const box = target.getBoundingClientRect();
      const to = {
        x: box.left - navBox.left,
        y: box.top - navBox.top,
        width: box.width,
        height: box.height,
        autoAlpha: 1,
      };

      // First placement jumps; afterwards it travels.
      if (!placedRef.current || reduced) {
        gsap.set(indicator, to);
        placedRef.current = true;
      } else {
        gsap.to(indicator, { ...to, duration: 0.42, ease: "power3.out" });
      }
    };

    place();
    window.addEventListener("resize", place);
    return () => window.removeEventListener("resize", place);
  }, [active]);

  const handleContactClick = () => {
    navigate("/contact-us");
     setOpen(false); 
  };

  const handleActive = (section) => {
     setOpen(false); 
    //  If user is not on homepage, go to homepage before scrolling
    navigate(`/#${section}`);
    if (window.location.pathname !== "/") {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const element = document.getElementById(section);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <> 
    {/* <header className={styles.topbar}>
      <div className={styles.left}>
        <img src={Logo} alt="Logo" className={styles.logoImage} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "8px",
            gap: "4px",
          }}
        >
          <div className={styles.logo}>Jose Charles Martin</div>
          <div className={styles.logo1}>Visionary Leader</div>
        </div>
      </div>

      <nav
        className={`${styles.nav} ${open ? styles.navOpen : ""}`}
        role="navigation"
        aria-label="Main"
      >
        <span
          className={`${styles.navItem} ${
            active === "home" ? styles.activeNav : ""
          }`}
          onClick={() => handleActive("home")}
        >
          Home
        </span>
        <span
          className={`${styles.navItem} ${
            active === "about" ? styles.activeNav : ""
          }`}
          onClick={() => handleActive("about")}
        >
          About
        </span>
        <span
          className={`${styles.navItem} ${
            active === "impact" ? styles.activeNav : ""
          }`}
          onClick={() => handleActive("impact")}
        >
          Impact
        </span>
        <span
          className={`${styles.navItem} ${
            active === "vision-mission" ? styles.activeNav : ""
          }`}
          onClick={() => handleActive("vision-mission")}
        >
          Vision & Mission
        </span>
        <span
          className={`${styles.navItem} ${
            active === "why-puducherry" ? styles.activeNav : ""
          }`}
          onClick={() => handleActive("why-puducherry")}
        >
          Why Puducherry
        </span>
        <button className={styles.profile} onClick={handleContactClick}>
          Contact Us
        </button>

        <span className={styles.mobileContact} onClick={handleContactClick}>
          Contact Us
          </span>

      </nav>

      <div className={styles.right}>
        <span onClick={() => setOpenTobBar(true)} className={styles.hamIcon}>
          {svg?.hamIcon}
        </span>

        <div className={styles.hamburger} onClick={() => setOpen(!open)}>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
        </div>
      </div>
    </header> */}
    {openTopBar ? <AdditionalTopBar setOpenTobBar={() => setOpenTobBar(false)} /> : <header className={styles.topbar}>
      <div className={styles.left}>
        <img src={Logo} alt="Logo" className={styles.logoImage} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "8px",
            gap: "4px",
          }}
        >
          <div className={styles.logo}>Jose Charles Martin</div>
          <div className={styles.logo1}>Visionary Leader</div>
        </div>
      </div>

      <nav
        className={`${styles.nav} ${open ? styles.navOpen : ""}`}
        ref={navRef}
        role="navigation"
        aria-label="Main"
      >
        {/* Travels behind the items; the active item just changes colour. */}
        <span className={styles.navIndicator} ref={indicatorRef} aria-hidden="true" />

        {NAV_ITEMS.map((item) => (
          <button
            type="button"
            key={item.section}
            data-section={item.section}
            aria-current={active === item.section ? "true" : undefined}
            className={`${styles.navItem} ${
              active === item.section ? styles.activeNav : ""
            }`}
            onClick={() => handleActive(item.section)}
          >
            {item.label}
          </button>
        ))}

        <button className={styles.profile} onClick={handleContactClick}>
          Contact Us
        </button>

        {/*  Contact button appears here inside dropdown for mobile */}
        <span className={styles.mobileContact} onClick={handleContactClick}>
          Contact Us
          </span>

      </nav>

      <div className={styles.right}>
        {/* The secondary bar only ever held Events, News and Gallery. Gallery
            is in the main nav now and the other two are parked, so there is
            nothing left for it to open. */}
        {/* <span onClick={() => setOpenTobBar(true)} className={styles.hamIcon}>
          {svg?.hamIcon}
        </span> */}

        {/* Mobile Hamburger Icon */}
        <div className={styles.hamburger} onClick={() => setOpen(!open)}>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
          <div className={styles.bar}></div>
        </div>
      </div>
    </header>}
    </>
  );
}
